import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { ROUTE_KNM } from 'CorePackage/MainModule/routes/routes';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';

import styles from './KnmListByPlanAccordionCell.module.scss';

export const KnmListByPlanLinksCell = ({ row }: ITableRenderCell<IKnmRaw>) => {
  return (
    <>
      {row.links &&
        row.links.length > 0 &&
        (row.links.length > 1 ? (
          <>
            <div className={styles.AccordionItem}>
              <a className="shared-table-link" href={ROUTE_KNM(row.links[0])} target="_blank" rel="noopener noreferrer">
                {row.links[0]}
              </a>
            </div>
            <AccordionWithButton
              content={row.links
                .filter((item, index) => item && index > 0)
                .map((item, index) => (
                  <div key={index} className={styles.AccordionItem}>
                    <a className="shared-table-link" href={ROUTE_KNM(item)} target="_blank" rel="noopener noreferrer">
                      {item}
                    </a>
                  </div>
                ))}
            />
          </>
        ) : (
          <a className="shared-table-link" href={ROUTE_KNM(row.links[0])} target="_blank" rel="noopener noreferrer">
            {row.links[0]}
          </a>
        ))}
    </>
  );
};
